import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as HeartIcon } from "../../images/svg/heart.svg";
import { ReactComponent as GrinIcon } from "../../images/svg/haha.svg";
import { ReactComponent as ThumbsUpIcon } from "../../images/svg/like.svg";
import { ReactComponent as WowIcon } from "../../images/svg/wow.svg";
import { ReactComponent as ClappingIcon } from "../../images/svg/clapping.svg";

const ChatReactionButton = ({ onReactionSelect }) => {
    const [showReactions, setShowReactions] = useState(false);
    const reactionRef = useRef(null);

    const reactions = [
        { icon: ThumbsUpIcon, key: "like" },
        { icon: HeartIcon, key: "love" },
        { icon: GrinIcon, key: "haha" },
        { icon: ClappingIcon, key: "clap" },
        { icon: WowIcon, key: "wow" },
    ];

    const handleReactionClick = (reactionKey) => {
        onReactionSelect(reactionKey);
        setShowReactions(false);
    };

    const toggleReactions = (e) => {
        e.stopPropagation();
        setShowReactions(!showReactions);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (reactionRef.current && !reactionRef.current.contains(event.target)) {
                setShowReactions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="reaction-button-container" ref={reactionRef}>
            {/* <button
                className="reaction-trigger"
                onClick={toggleReactions}
                title="Add reaction"
            >
                ☺
            </button> */}
            {showReactions && (
                <div className="reaction-popup">
                    {reactions.map(({ icon: Icon, key }) => (
                        <button
                            key={key}
                            className="reaction-option"
                            onClick={() => handleReactionClick(key)}
                        >
                            <Icon width="20" height="20" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ChatReactionButton;
